module.exports = __webpack_public_path__ + "static/icon_Ablos-03f9e513dcfee4b866fe20ddf56b8b22.png";